var map = {
	"./en.json": 65,
	"./es.json": 205,
	"./fr.json": 206
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;


//////////////////
// WEBPACK FOOTER
// ./lmm-widget/src/data/locales ^\.\/.*\.json$
// module id = 204
// module chunks = 1